import React, { useState } from "react";
import "./UploadStyle.css";
import FileUpload from "./FileUpload";
import ManualUpload from "./ManualUpload";
import ReusableTabs from "../../pages/ReusableTabs";

// const UploadPage = () => {
//   const [uploadType, setUploadType] = useState("file");

//   return (
//     <div>
//       <div className="button-container">
//         <button
//           className={`${uploadType === "file" && "text-cyan-600"}`}
//           onClick={() => setUploadType("file")}
//         >
//           File Upload
//         </button>
//         |
//         <button
//           className={`${uploadType === "manual" && "text-cyan-600"}`}
//           onClick={() => setUploadType("manual")}
//         >
//           Shift Layup Serial Nos.
//         </button>
//         <hr></hr>
//       </div>
//       {uploadType === "file" && <FileUpload />}
//       {uploadType === "manual" && <ManualUpload />}
//     </div>
//   );
// };

const UploadPage = () => {
  const [activeTab, setActiveTab] = useState(0);
  const tabs = [
    { label: 'File Upload', component: <FileUpload /> },
    { label: 'Shift Layup Serial Nos.', component: <ManualUpload /> },
  ];

  return (
    <ReusableTabs 
      tabs={tabs}
      defaultTab={0}
      activeTab={activeTab}        
      onTabChange={setActiveTab}   
      panelStyles={{ padding: '16px' }}
    />
  );
}

export default UploadPage;
